<template>
    <div class="personal_info">
        <div class="card_info">
            <div class="edit_icon">
                <cl-more
                    v-if="isTs"
                    width="24"
                    height="24"
                    :options="actionOptions"
                    iconClass="more_gary"
                    @click="handleCommand"
                ></cl-more>
            </div>
            <!-- 球员/教练员基础信息 -->
            <div class="card_content" v-if="dynamicFieldData && dynamicFieldData.length">
                <div v-for="(item, index) in dynamicFieldData" :key="index">
                    <hr v-if="index !== 0" class="Split_Line mt40 mb40" />
                    <!-- 标题 -->
                    <p class="title">{{ item['name' + $lang2] }}</p>
                    <!-- 内容 -->
                    <div class="card_row">
                        <template v-for="el in item.fields">
                            <!-- 表单 -->
                            <dl v-if="el.type !== 'table'" :key="el.id">
                                <dt>{{ el['name' + $lang2] }}</dt>
                                <dd
                                    v-if="el.type === 'select' || el.type === 'dict'"
                                >{{ (el.value && tableSelectDataFn(el.property, el.value)) || defaultText }}</dd>
                                <dd v-else-if="el.type === 'file'">
                                    <cl-file-list
                                        v-if="el.value && el.value.length"
                                        v-model="el.value"
                                        disabled
                                        :customizeDownLoad="true"
                                        @downFile="downFile"
                                    ></cl-file-list>
                                    <span v-else>{{ defaultText }}</span>
                                </dd>
                                <dd
                                    v-else-if="el.type === 'textarea'"
                                    style="white-space: normal;"
                                >{{ el.value || defaultText }}</dd>
                                <dd v-else>{{ el.value || defaultText }}</dd>
                            </dl>
                            <!-- 表格 -->
                            <div v-else :key="el.id" style="width: 100%;">
                                <el-table
                                    :data="el.tableData"
                                    style="width: 100%"
                                    class="custom_table table_hover"
                                    header-cell-class-name="table_header"
                                    row-class-name="table_row"
                                    :empty-text="$t('common.暂无数据')"
                                    :cell-style="{ height: '60px' }"
                                >
                                    <el-table-column
                                        v-for="(columnItem, columnIndex) in el.property"
                                        :key="columnIndex"
                                        :label="columnItem['name' + $lang2]"
                                    >
                                        <template slot-scope="{row}">
                                            <template
                                                v-if="columnItem.type === 'select'"
                                            >{{ (row && tableSelectDataFn(columnItem.property, row[columnItem.key])) || defaultText }}</template>
                                            <template
                                                v-else
                                            >{{ (row && row[columnItem.key]) || defaultText }}</template>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'dynamic-field-info',
    props: {
        // 是否是球员
        isPlayer: {
            type: Boolean,
            default: false,
        },
        // 人员信息
        peopleInfo: {
            type: Object,
            default: () => { },
        },
        // 是否是从ts过来的
        isTs: {
            type: Boolean,
        },
        // 动态字段
        dynamicFieldArr: {
            type: Array,
        },
    },
    data () {
        return {
            defaultText: this.$nullText, // 默认占位符
            dynamicFieldData: []
        }
    },
    watch: {
        dynamicFieldArr: {
            immediate: true,
            deep: true,
            async handler (newV) {
                if (newV) {
                    for (const item of newV) {
                        for (const el of (item.fields || [])) {
                            if(el.type === 'dict') {
                                await this.getDictionary(newV, el);
                            }
                        }
                    }
                    this.dynamicFieldData = newV
                }
            }
        },
    },
    computed: {
        // 右上角操作
        actionOptions () {
            const arr = [
                {
                    label: '合并',
                    labelEn: 'merge',
                    value: 'merge',
                    class: 'ts_merge_ash',
                },
                {
                    label: '编辑',
                    labelEn: 'Edit',
                    value: 'edit',
                    class: 'edit',
                },
            ]
            if (this.peopleInfo.tsStatus == 0) {
                return [
                    {
                        label: '转为新球员',
                        labelEn: 'New',
                        value: 'new',
                        class: 'add_new_player',
                    },
                    ...arr,
                ]
            } else {
                return arr
            }
        },
    },
    methods: {
        // 下载
        async downFile (row) {
            const res = await this.$server.getBolbByOssUrl(row.url)
            this.$utils.downloadByAlabel(res, row.name)
        },
        // 固定下拉
        tableSelectDataFn (option, value) {
            if (!value) return
            if (option.multi) {
                // 多选
                let arr = []
                value.forEach(item => {
                    let obj = option.data.find(v => v.key === item)
                    // TODO: CMS字典驼峰改下划线后，删掉obj['name' + this.$lang]
                    arr.push(obj['name' + this.$lang] || obj['name' + this.$lang2])
                })
                return arr.join(',')
            } else {
                // 单选
                let obj = option.data.find(v => v.key === value)
                // TODO: CMS字典驼峰改下划线后，删掉obj['name' + this.$lang]
                return obj ? obj['name' + this.$lang] || obj['name' + this.$lang2] : ''
            }
        },
        // 字典下拉
        async getDictionary (allData, row) {
            const { data } = await this.$server.getDictionary({ key: row.property.dictCode })
            allData.forEach(item => {
                item.fields.forEach(el => {
                    // 处理字典类型下拉数据，动态字段接口未返回下拉数据
                    if (el.id === row.id) {
                        el.property.data = data.data.map(v => {
                            return {
                                ...v,
                                key: v.value
                            }
                        })
                    }
                })
            })
        },
        // 跳转
        handleCommand (key) {
            this.$emit('moreClick', key)
        },
    },
}
</script>

<style lang="scss" scoped>
/deep/ .el-form-item__content {
    line-height: 20px;
}
::v-deep .default_text {
    color: #b7b7bf;
}
</style>
